module.exports = __webpack_public_path__ + "img/public/SiteIcons/facebookIcon.svg?ec0e5749";